import { ApiClient } from "../../account/models/ApiClient";
import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminCampaignApi = {
  triggerTroubleshoot: async (campaignId: string) => {
    return await jwtAuthAxios().post<ApiClient[]>(
      `/admin/campaigns/${campaignId}/trigger-troubleshoot`
    );
  },
};
